import { useQuery } from '@tanstack/react-query'

export default function useUtilities() {
  const { data } = useQuery(['/api/asset-types'], {
    refetchOnMount: false,
    retry: false,
  })
  const assetTypes = data ? data : []

  return {
    assetTypes,
  }
}
